/* Tia Lorens — strelice ‹ › na galeriji proizvoda (desktop) */
(function () {
  function init() {
    document.querySelectorAll('.tia-product-redesign media-gallery').forEach(function (g) {
      if (g.dataset.tlArrows) return;
      var viewer = g.querySelector('slider-component:not(.thumbnail-slider)'); if (!viewer) return;
      var items = viewer.querySelectorAll('.product__media-item'); if (items.length < 2) return;
      g.dataset.tlArrows = '1';
      function step(d) {
        var list = Array.prototype.slice.call(viewer.querySelectorAll('.product__media-item'));
        var i = list.findIndex(function (el) { return el.classList.contains('is-active'); }); if (i < 0) i = 0;
        var n = (i + d + list.length) % list.length; var id = list[n].dataset.mediaId;
        if (id && typeof g.setActiveMedia === 'function') g.setActiveMedia(id, false);
      }
      function mk(dir) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'tl-gallery-arrow tl-gallery-arrow--' + dir;
        b.setAttribute('aria-label', dir === 'prev' ? 'Prethodna slika' : 'Sledeća slika');
        b.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="' + (dir === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>';
        b.addEventListener('click', function (e) { e.preventDefault(); step(dir === 'prev' ? -1 : 1); }); return b;
      }
      viewer.appendChild(mk('prev')); viewer.appendChild(mk('next'));
      document.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') step(-1); if (e.key === 'ArrowRight') step(1); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Paketi + traka do besplatne dostave + preusmerenje na checkout sa oba artikla */
(function () {
  function fmt(n) { return Math.round(n / 100).toLocaleString('sr-RS').replace(/\s/g, '.') + ' RSD'; }
  function init() {
    var root = document.querySelector('[data-tl-bundles]'); if (!root || root.dataset.tlInit) return; root.dataset.tlInit = '1';
    var threshold = parseInt(root.dataset.threshold, 10) || 1400000, limited = root.dataset.limited === 'true';
    var bar = root.querySelector('[data-tl-ship-bar]'), text = root.querySelector('[data-tl-ship-text]');
    var variants = {}; root.querySelectorAll('script[data-tl-variants]').forEach(function (s) { try { variants[s.dataset.tlVariants] = JSON.parse(s.textContent); } catch (e) {} });
    function selected() { return root.querySelector('.tl-bundle.is-active'); }
    function update() {
      var sub = parseInt(selected().dataset.subtotal, 10) || 0;
      if (limited || sub >= threshold) { bar.style.width = '100%'; root.classList.add('is-free'); text.innerHTML = '<b>✓ Besplatna dostava</b>' + (limited && sub < threshold ? ' — Limited Edition' : ''); }
      else { var pct = Math.max(6, Math.min(100, Math.round(sub / threshold * 100))); bar.style.width = pct + '%'; root.classList.remove('is-free'); text.innerHTML = 'Još <b>' + fmt(threshold - sub) + '</b> do besplatne dostave'; }
    }
    root.querySelectorAll('.tl-bundle').forEach(function (l) {
      l.addEventListener('click', function () { root.querySelectorAll('.tl-bundle').forEach(function (x) { x.classList.remove('is-active'); }); l.classList.add('is-active'); var r = l.querySelector('input'); if (r) r.checked = true; update(); });
    });
    // "2 seta": izbor drugog seta (boja)
    var twoCard = root.querySelector('.tl-bundle[data-kind="two"]');
    if (twoCard) twoCard.querySelectorAll('.tl-pick').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        twoCard.querySelectorAll('.tl-pick').forEach(function (x) { x.classList.remove('is-on'); }); b.classList.add('is-on');
        twoCard.dataset.partner = 'two:' + b.dataset.handle; twoCard.dataset.subtotal = b.dataset.subtotal;
        var img = twoCard.querySelector('[data-tl-two-img]'); if (img) img.src = b.dataset.img;
        var pr = twoCard.querySelector('[data-tl-two-price]'); if (pr) pr.textContent = b.dataset.price;
        var fu = twoCard.querySelector('[data-tl-two-full]'); if (fu) fu.textContent = b.dataset.full;
        root.querySelectorAll('.tl-bundle').forEach(function (x) { x.classList.remove('is-active'); }); twoCard.classList.add('is-active'); var r = twoCard.querySelector('input'); if (r) r.checked = true;
        update();
      });
    });
    update();
    // klik na "Poruči odmah": ako je paket, idi na checkout sa oba artikla
    var form = document.querySelector('form[data-type="add-to-cart-form"]'); if (!form) return;
    var go = function (e) {
      var sel = selected(); if (!sel || sel.dataset.kind === 'single') return;
      var idInput = form.querySelector('input[name="id"]'); var curId = idInput && parseInt(idInput.value, 10); if (!curId) return;
      var norm = function (s) { return String(s || '').trim().toUpperCase().split(/[\s(]/)[0]; }; // "XS/S (55-65kg)" i "XS/S (do 65 kg)" -> "XS/S"
      var cur = (variants.current || []).find(function (v) { return v.id === curId; }); var size = cur ? norm(cur.size) : null;
      var list = variants[sel.dataset.partner] || []; var partner = list.find(function (v) { return norm(v.size) === size && v.available; }) || list.find(function (v) { return norm(v.size) === size; }) || list.find(function (v) { return v.available; }) || list[0];
      if (!partner) return;
      e.preventDefault(); e.stopImmediatePropagation();
      window.location.href = partner.id === curId ? '/cart/' + curId + ':2' : '/cart/' + curId + ':1,' + partner.id + ':1';
    };
    form.addEventListener('submit', go, true);
    var btn = form.querySelector('.product-form__submit'); if (btn) btn.addEventListener('click', go, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
